export default __webpack_public_path__ + "static/media/jhonathan-osorio-at-caq-soccer-41-of-43.4cb33aa4.jpeg";